import React, { FC, useState } from 'react';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';

import { usePost } from '../../../sharedModules/hooks/useQuery';

interface ImportHomeInspectionJobModalProps {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

interface ImportResult {
  success: boolean;
  imported_count: number;
  skipped_count: number;
  error_count: number;
  message: string;
  order_no?: string;
  error?: string;
}

const ImportHomeInspectionJobModal: FC<ImportHomeInspectionJobModalProps> = (props) => {
  const { open, onClose, onSuccess } = props;

  const [orderNo, setOrderNo] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [successMessage, setSuccessMessage] = useState<string>('');

  const { mutateAsync, isPending } = usePost();

  const handleCloseModal = () => {
    setOrderNo('');
    setErrorMessage('');
    setSuccessMessage('');
    onClose();
  };

  const handleImport = async () => {
    const trimmed = orderNo.trim();
    if (!trimmed) {
      setErrorMessage('Order number is required');
      return;
    }

    setErrorMessage('');
    setSuccessMessage('');
    try {
      const response = await mutateAsync({
        url: '/home_services/inspection_jobs',
        data: { order_no: trimmed },
      });
      const data = response?.data as ImportResult | undefined;
      if (data?.success) {
        setSuccessMessage(data.message ?? 'Import completed successfully.');
        onSuccess();
        setTimeout(handleCloseModal, 2000);
      } else {
        setErrorMessage(data?.message ?? data?.error ?? 'Import did not complete successfully.');
      }
    } catch (error: any) {
      if (error.response?.data?.error) {
        setErrorMessage(error.response.data.error);
      } else {
        setErrorMessage('Something went wrong importing the home inspection job');
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleCloseModal}
      aria-labelledby="import-work-order-dialog-title"
      aria-describedby="import-work-order-dialog-description"
      fullWidth
    >
      <DialogTitle id="import-work-order-dialog-title">Import Work Order</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={12} style={{ marginTop: 10 }}>
            <TextField
              autoFocus
              label="Order No"
              type="text"
              fullWidth
              InputLabelProps={{
                shrink: true,
              }}
              variant="outlined"
              value={orderNo}
              onChange={(e) => setOrderNo(e.target.value)}
            />
          </Grid>
          <Grid item xs={12}>
            {errorMessage && (
              <Typography style={{ color: 'red', textAlign: 'left', fontSize: 14 }}>{errorMessage}</Typography>
            )}
            {successMessage && (
              <Typography style={{ color: 'green', textAlign: 'left', fontSize: 14 }}>{successMessage}</Typography>
            )}
          </Grid>
          <Grid item xs={12}>
            <Button color="primary" variant="contained" disabled={isPending || !orderNo.trim()} onClick={handleImport}>
              Import
            </Button>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default ImportHomeInspectionJobModal;
